export default __webpack_public_path__ + "static/media/Deli-Sandwich.b9cb07fd.jpg";